module.exports = __webpack_public_path__ + "img/logo-mtl-en-commun.9511c763.png";